import type { FaqEntry } from '@/lib/structured-data'

export const HOME_FAQS: FaqEntry[] = [
    {
        question: 'How is the information on Smile Design Secret put together?',
        answer: "Every guide is researched from current clinical guidelines and trusted dental sources, then written in plain English for patients. Articles are revisited as recommendations change. For anything specific to your own mouth, always check with your dentist."
    },
    {
        question: 'Is Smile Design Secret free to use?',
        answer: 'Yes. All of our guides are completely free to read, with no account required and no paywall.'
    },
    {
        question: 'Can these guides replace a visit to my dentist?',
        answer: "No. Our articles are for general education only and are not a substitute for professional dental advice, diagnosis, or treatment. Always consult your dentist about your individual needs."
    },
    {
        question: 'What topics does Smile Design Secret cover?',
        answer: 'We focus on three areas: cosmetic dentistry, everyday dental health, and general dentistry. Each one is organised into its own topic hub of in-depth, easy-to-read guides.'
    },
    {
        question: 'How often is the content updated?',
        answer: 'Guides are revisited and refreshed as clinical recommendations and best practice evolve, so the advice you read stays current and trustworthy.'
    }
]
